import clsx from 'clsx';
import React from 'react';

interface CustomRadioProps {
  isSelected: boolean;
}

const CustomRadio = ({ isSelected }: CustomRadioProps) => {
  return (
    <span
      className={clsx(
        'tw-flex-none tw-relative tw-mr-8 tw-border tw-border-slate-200 tw-border-solid tw-rounded-full tw-h-28 tw-w-28 after:tw-block tw-bg-white',
        {
          "after:tw-absolute after:tw-top-3 after:tw-left-3 after:tw-h-20 after:tw-w-20 \
              after:tw-content-[''] after:tw-bg-primary-red after:tw-rounded-full": isSelected,
        }
      )}
    ></span>
  );
};

export default CustomRadio;
